const DOMAINS = {
  test: 'portal-test.retaintive.ai',
  pre: 'portal-pre.retaintive.ai',
  prod: 'portal.retaintive.ai',
};

type Stage = 'test' | 'pre' | 'prod';

function getStageFromDomain(): Stage {
  const domain = globalThis.location.hostname;
  if (domain === DOMAINS.prod) {
    return 'prod';
  }
  if (domain === DOMAINS.pre) {
    return 'pre';
  }
  return 'test';
}

export const stage = getStageFromDomain();
